<form [formGroup]="googleAddressForm">
    <div class="form-group">
        <div class="text-box-wrap">
            <label>*Map Location</label>
            <input type="text" class="form-control" (keydown.enter)="$event.preventDefault()" [ngClass]="{'is-invalid': formErrors.googleAddressLoc}"
                placeholder="Street Address" formControlName="googleAddressLoc" autocorrect="off" autocapitalize="off"
                spellcheck="off" (keyup)="validateLocation()" #searchLocation>
               <span *ngIf="isValid">{{mapAddress?.latitude}},{{mapAddress?.longitude}}</span>
            <div *ngIf="fc.googleAddressLoc.errors" class="invalid-feedback">
                <div *ngIf="fc.googleAddressLoc.errors.required">
                    Please enter Location
                </div>
            </div>
        </div>
    </div>
</form>